/**
 * Mendeteksi apakah error disebabkan oleh masalah jaringan/server
 * (bukan karena autentikasi atau akun dinonaktifkan)
 * Jika true: JANGAN logout user - biarkan retry atau tampilkan pesan error
 */
export function isNetworkOrServerError(error) {
  if (!error) return false;

  // Tidak ada response = kemungkinan network error
  if (!error.response) {
    const code = error.code || "";
    const message = (error.message || "").toLowerCase();
    return (
      code === "ERR_NETWORK" ||
      code === "ECONNABORTED" ||
      code === "ECONNREFUSED" ||
      code === "ETIMEDOUT" ||
      code === "ENOTFOUND" ||
      message.includes("network error") ||
      message.includes("failed to fetch")
    );
  }

  // 5xx = server error (bukan salah user)
  const status = error.response?.status;
  if (status >= 500) return true;

  // 408 Request Timeout
  if (status === 408) return true;

  // 502, 503, 504 = gateway/server unavailable
  if ([502, 503, 504].includes(status)) return true;

  return false;
}

/**
 * Mendeteksi apakah 403 adalah karena akun dinonaktifkan (status_EO)
 * Hanya ini yang boleh trigger forceLogout
 */
export function isInactiveAccountError(error) {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.status_EO != null
  );
}
